import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Alert, Button, Card, CardBody, Container } from "reactstrap";
import { getStoredUser } from "../../../api/auth";
import { canAccessCredoraPath, roleHomePath } from "../../../constants/menuAccess";
import { DEFAULT_LAYOUT_SLUG } from "../../../constants/layout";
import { resolveLayoutSlug } from "../../../Layout/Sidebar/Menu";
import { isSuperAdmin, roleLabel } from "../../../constants/credoraRoles";

const CredoraAccessGate = ({ children }) => {
  const location = useLocation();
  const user = getStoredUser();
  const layoutSlug = resolveLayoutSlug(location.pathname, DEFAULT_LAYOUT_SLUG);

  if (!user?.role || isSuperAdmin(user)) {
    return children;
  }

  if (canAccessCredoraPath(user, location.pathname)) {
    return children;
  }

  const home = roleHomePath(user, layoutSlug);

  return (
    <Container fluid className="py-5">
      <Card className="mx-auto" style={{ maxWidth: 520 }}>
        <CardBody className="text-center p-4">
          <h4 className="mb-2">Access restricted</h4>
          <p className="text-muted mb-3">
            Your role ({roleLabel(user.role)}) does not include permission to open this page. Contact an administrator
            if you need access.
          </p>
          <Alert color="light" className="text-start small mb-3">
            <code>{location.pathname}</code>
          </Alert>
          <Button tag={Link} to={home} color="primary">
            Go to your home page
          </Button>
        </CardBody>
      </Card>
    </Container>
  );
};

export default CredoraAccessGate;
